import { i18next } from '@yola/ws-sdk';
import pageTypes from '../constants/page-types';

const getPageNameByType = (type) => {
  switch (type) {
    case pageTypes.HOME:
      return i18next.t('Home');
    case pageTypes.ABOUT_US:
      return i18next.t('About us');
    case pageTypes.SERVICES:
      return i18next.t('Services');
    case pageTypes.PRODUCTS:
      return i18next.t('Products');
    case pageTypes.MENU:
      return i18next.t('Menu');
    case pageTypes.OUR_WORK:
      return i18next.t('Our work');
    case pageTypes.CONTACT_US:
      return i18next.t('Contact us');
    case pageTypes.TESTIMONIALS:
      return i18next.t('Testimonials');
    case pageTypes.FAQ:
      return i18next.t('FAQ');
    case pageTypes.ALL_BLOCKS:
      return 'All blocks'; // Not translated as it's a technical page
    case pageTypes.EMPTY_PAGE:
    default:
      return i18next.t('Untitled');
  }
};

export default getPageNameByType;
